import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { HomeState } from './home.state';
import { Observable } from 'rxjs';
import { ResetStore, SetActiveRecord } from './home.actions';
import { ActiveRecord, Record } from '../../models/record';
import { ActiveRecordFacade } from '../core/active-record-facade';

@Injectable({
  providedIn: 'root',
})
export class HomeFacade implements ActiveRecordFacade {
  private readonly store = inject(Store);

  @Select(HomeState.activeRecord) activeRecord$: Observable<ActiveRecord | undefined>;

  get activeRecord(): ActiveRecord | undefined {
    return this.store.selectSnapshot(HomeState.activeRecord);
  }

  clearStore() {
    this.store.dispatch(new ResetStore());
  }

  setActiveRecord(record: Record, collectionId: number, selectedIndex: number) {
    this.store.dispatch(new SetActiveRecord({ ...record, collectionId, sliderIndex: selectedIndex }));
  }
}
